import styles from './BarList.module.css'

// Adapted from BoardUI 0.5.9 bar-list-card.tsx, retrieved through its
// licensed MCP: https://www.boardui.com/components/bar-list-card.
// Keep its rounded background bars, 14%/26% tint and overlaid label/value.
// Studio supplies ordered rows, exact formatted values, fitting and actions.
export function BoardBarList({ items, label, series, rowHeight }) {
  return (
    <ol className={styles.list} aria-label={label} data-series={series} style={{ '--boardui-bar-row-height': `${rowHeight}px` }}>
      {items.map((item) => {
        const body = (
          <>
            <span className={styles.bar} aria-hidden="true" style={{ width: item.width }} />
            <span className={styles.name}>
              {item.icon ? <span className={styles.icon}>{item.icon}</span> : null}
              <span className={styles.label} title={item.label}>{item.label}</span>
            </span>
            <span className={styles.value}>{item.value}</span>
          </>
        )
        return (
          <li key={item.key} className={styles.row}>
            {item.onSelect ? (
              <button type="button" className={styles.body} onClick={item.onSelect}>{body}</button>
            ) : <span className={styles.body}>{body}</span>}
          </li>
        )
      })}
    </ol>
  )
}
